/**
 * Drži "Šifra: XXX" u meta liniji PDP-a u skladu sa izabranom varijantom.
 *
 * Liniju crta custom_liquid blok `meta_info` (uz Kategoriju i Brend) da bi se stopila sa
 * postojećim stilom, ali custom_liquid se renderuje na serveru i tema ga ne osvežava pri
 * promeni modela — izmereno: šifra je ostajala na prvoj varijanti kroz sve izbore.
 *
 * Podaci se ne dovlače: tema već ispisuje ceo niz varijanti (uključujući `sku`) u
 * <script type="application/json"> koji koristi variant picker, a izabrani ID stoji u
 * skrivenom polju [name="id"] unutar forme za korpu. Odavde se samo čitaju.
 */
(function () {
  var line = document.querySelector('[data-pdp-sku]');
  if (!line) return;
  var value = line.querySelector('strong');
  if (!value) return;

  var variants = null;
  Array.prototype.forEach.call(document.querySelectorAll('script[type="application/json"]'), function (node) {
    if (variants) return;
    try {
      var parsed = JSON.parse(node.textContent);
      if (Array.isArray(parsed) && parsed.length && parsed[0] && 'sku' in parsed[0] && 'id' in parsed[0]) {
        variants = parsed;
      }
    } catch (e) {
      /* drugi JSON blokovi na stranici (shopify-features i sl.) — preskoči */
    }
  });
  if (!variants) return;

  function selectedId() {
    var form = document.querySelector('form[action*="/cart/add"]');
    var input = form && form.querySelector('[name="id"]');
    return input ? input.value : null;
  }

  function update() {
    var id = selectedId();
    if (!id) return;
    var variant = null;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(id)) { variant = variants[i]; break; }
    }
    if (!variant) return;
    var sku = (variant.sku || '').trim();
    // Proizvod bez šifre (1 od 1551) ne treba da pokazuje prazan red.
    line.style.display = sku ? '' : 'none';
    // Uslov nije kozmetika: upis u textContent je i sam childList izmena, pa bi bez
    // njega observer ispod pozivao update() u krug.
    if (sku && value.textContent !== sku) value.textContent = sku;
  }

  update();
  document.addEventListener('change', update);
  new MutationObserver(update).observe(document.body, { childList: true, subtree: true });
})();
